export default {
  create_warehouse_btn: 'Create new Warehouse',
  filter: {
    search: {
      placeholder: 'Filter warehouses list'
    },
    country: {
      all_option: 'All Countries'
    },
    status: {
      all_option: 'All Statuses'
    },
    sort: {
      new_to_old: 'New to old',
      old_to_new: 'Old to new'
    }
  },
  table_card: {
    set_selected_status_to: 'Set status for {count} warehouses to : ',
    buttons: {
      apply: 'Apply'
    },
    table: {
      creation_date: 'Creation date',
      warehouse: 'Warehouse',
      contact_name: 'Contact name',
      Contact_details: 'Contact details',
      countries: {
        title: 'Countries',
        others: '{nb} others'
      },
      last_month_confirmed_sales: 'Last 30 days confirmed sales',
      status: 'Status',
      actions: 'Actions'
    }
  },
  form: {
    toggle_form: 'Click here to create a warehouse',
    warehouse_form: {
      create_warehouse: {
        title: 'Create Warehouse',
        subtitle: 'Create new warehouse for your products'
      },
      update_warehouse: {
        title: 'Update Warehouse',
        subtitle: 'Update warehouse'
      },
      buttons: {
        create: 'Create warehouse',
        save: 'Save warehouse',
        duplicate: 'Duplicate warehouse',
        cancel: 'Cancel'
      },
      fields: {
        owner: {
          title: 'Owner'
        },
        name: {
          title: 'Warehouse name',
          placeholder: 'Type a name'
        },
        user_name: {
          title: 'Username',
          placeholder: 'Type a username'
        },
        contact_name: {
          title: 'Contact name',
          placeholder: 'Type a contact name'
        },
        email: {
          title: 'Email',
          placeholder: 'example@example.com'
        },
        password: {
          title: 'Password',
          placeholder: 'Password'
        },
        confirmation: {
          title: 'Password confirmation',
          placeholder: 'Repeat the password'
        },
        phone: {
          title: 'Phone',
          placeholder: 'Type a phone'
        },
        skype: {
          title: 'Skype id',
          placeholder: 'Type the skype id'
        },
        country_select_type: {
          title: 'Country select type'
        },
        countries: {
          title: 'Warehouse Countries',
          hint: 'What are the target regions ?'
        },
        country: {
          title: 'Warehouse countries',
          sub_title: 'Define warehouse inventory countries, and optionally set fulfillment and shipping costs by country.',
          add_button: 'Add Country'
        },
        activate_call_center: {
          title: 'Activate call center'
        }
      },
      define_warehouse_costs: 'Define warehouse costs in usd by country for fulfillment, upsells and shipping costs',
      country_cost_table: {
        country: 'Country',
        fulfillment: 'Fulfillment',
        upsell: 'Upsell',
        shipping: 'Shipping',
        returns: 'Returns',
        tax: 'Tax %',
        other: 'Other %',
        actions: 'Actions'
      }
    },
    call_agent_form: {
      create_call_agent: {
        title: 'Create Call Agent',
        subtitle: 'Create the main call agent for this warehouse'
      },
      update_call_agent: {
        title: 'Update Call Agent',
        subtitle: 'Update call agent'
      }
    }
  }
};